/**
 * @generated SignedSource<<a2f17092fa16baf03722f9872bc56f5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteSettlementInput = {
  id: string;
};
export type DeleteSettlementDialogMutation$variables = {
  input: DeleteSettlementInput;
};
export type DeleteSettlementDialogMutation$data = {
  readonly deleteSettlement: {
    readonly id: string;
  };
};
export type DeleteSettlementDialogMutation = {
  response: DeleteSettlementDialogMutation$data;
  variables: DeleteSettlementDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteSettlementDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IdPayload",
        "kind": "LinkedField",
        "name": "deleteSettlement",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteSettlementDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IdPayload",
        "kind": "LinkedField",
        "name": "deleteSettlement",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "57d7db0683ffa3fbfc4ff18474ee385c",
    "id": null,
    "metadata": {},
    "name": "DeleteSettlementDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteSettlementDialogMutation(\n  $input: DeleteSettlementInput!\n) {\n  deleteSettlement(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "32bc2a6978509774cbc351b8793af578";

export default node;
